import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a wall-mounted white panel radiator authored at its true
// mounting height: a slim panel 0.8 x 0.6 m spanning y = 0.15..0.75 against
// the wall at z = 0, four thin vertical ribs proud of the face and a small
// steel valve knob at the +X end.
const PANEL = "#efece6";
const STEEL = "#aab2b8";

export const radiatorPanel = defineModel({
  id: "radiator-panel",
  batchId: "modern",
  name: "Radiator panel",
  tags: ["modern", "interior", "fixture", "heating", "radiator", "wall-mounted"],
  summary: "A wall-mounted white panel radiator with vertical ribs and a valve.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // slim panel body (small gap off the wall)
      { geometry: new THREE.BoxGeometry(0.8, 0.6, 0.06), color: PANEL, position: [0, 0.45, 0.05] },
      // four vertical ribs proud of the face
      { geometry: new THREE.BoxGeometry(0.1, 0.54, 0.02), color: PANEL, position: [-0.27, 0.45, 0.09] },
      { geometry: new THREE.BoxGeometry(0.1, 0.54, 0.02), color: PANEL, position: [-0.09, 0.45, 0.09] },
      { geometry: new THREE.BoxGeometry(0.1, 0.54, 0.02), color: PANEL, position: [0.09, 0.45, 0.09] },
      { geometry: new THREE.BoxGeometry(0.1, 0.54, 0.02), color: PANEL, position: [0.27, 0.45, 0.09] },
      // valve pipe stub at the +X end
      { geometry: new THREE.BoxGeometry(0.06, 0.03, 0.03), color: STEEL, position: [0.43, 0.2, 0.05] },
      // valve knob
      {
        geometry: new THREE.CylinderGeometry(0.028, 0.028, 0.035, 10),
        color: STEEL,
        position: [0.475, 0.2, 0.05],
        rotation: [0, 0, Math.PI / 2],
      },
    ];
  },
  animations: [],
});
